import API_URL from '@/config';
import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

export function initSocket(token?: string) {
  // Always disconnect old socket before creating new one
  if (socket) {
    if (socket.connected) {
      socket.disconnect();
    }
    socket = null;
  }

  socket = io(API_URL, {
    autoConnect: true, // let it auto connect
    auth: token ? { token } : {},
    transports: ['websocket'],
  });

  // Optional: debug connection events
  socket.on('connect', () => {
    console.log('✅ Socket connected:', socket?.id);
  });

  socket.on('disconnect', (reason) => {
    console.log('❌ Socket disconnected:', reason);
  });

  socket.on('connect_error', (err) => {
    console.error('⚠️ Socket connect error:', err.message);
  });

  return socket;
}

export function getSocket() {
  if (!socket) {
    throw new Error("Socket not initialized. Call initSocket() first.");
  }
  return socket;
}
